import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import FullBanner from "../components/Sections/FullBanner";
import Brands from "../components/Sections/Brands";
import Products from "../components/Sections/Products";
import Footer from "../components/Sections/Footer"
import Location from "../components/Sections/Location";
import FloatWppIcon from "../components/Elements/FloatWppIcon";
import TestimonialSlider from "../components/Elements/TestimonialSlider";

export default function Home() {
  return (
    <>
      <TopNavbar />
      <FullBanner />
      <Brands />
      <Products />
      <Location />
      <TestimonialSlider />
      <FloatWppIcon />
      <Footer />
    </>
  );
}


